import React, { useContext, useMemo, useState } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import CarrierOptionsPanel from '../components/panels/CarrierOptionsPanel';
import { AuthContext } from '../contexts/authContext';
import {
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierOptionsPage = ({ disableLayout, routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const userHasPermission = useUserPermission();
  const [headerActions, setHeaderActions] = useState(null);

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'optionPermission');

  const content =
    canView && (
      <>
        <StickyPageHeader
          actions={headerActions}
          subtitle={selectedCarrier.name}
          title="Options"
        />
        <CarrierOptionsPanel
          carrier={selectedCarrier}
          id="options"
          userRole={authUser?.role}
          onHeaderActions={setHeaderActions}
        />
      </>
    );

  if (disableLayout) {
    return content || null;
  }

  return (
    <Layout
      carrierLoading={!selectedCarrier}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {content}
    </Layout>
  );
};

export default CarrierOptionsPage;
